import { Component, OnInit, Input, EventEmitter, Output } from '@angular/core';
import { TabulatorService, TransformationService, TimeoutWrapper } from '@nrwl/common-lib';
import { Options } from 'tabulator-tables';
@Component({
  selector: 'nrwl-cart-list-table',
  templateUrl: './cart-list-table.component.html',
  styleUrls: ['./cart-list-table.component.scss'],
  providers: [TimeoutWrapper]
})
export class CartListTableComponent implements OnInit {
  @Input() cartItems;
  @Output() openPickerView?: EventEmitter<any> = new EventEmitter();
  @Output() updateCartItems?: EventEmitter<any> = new EventEmitter();
  show: boolean;
  table: Options;
  timeout: TimeoutWrapper;
  constructor(
    private tabulatorService: TabulatorService,
    private transformationService: TransformationService,
    timeout: TimeoutWrapper
  ) {
    this.timeout = timeout;
    this.show = false;
    this.table = this.tabulatorService.commonTableConfiguration();
    this.table.persistenceID = 'cart-table';
    this.table.groupHeader = this.tabulatorService.groupHeader;
    this.table.initialSort = [{ column: 'name', dir: 'desc' }];
  }

  ngOnInit(): void {
    this.table.initialSort = [
      {
        column: 'name.label',
        dir: 'asc'
      }
    ];
    this.createTable();
  }
  createTable(): void {
    const transformedData = this.transformationService.getTemplate('cart-page');
    this.table.height = 500;
    this.table.rowHeight = 40;
    this.table;
    this.table.columns = transformedData.column;
    this.table.data = this.cartItems;
    if (this.table.persistence) {
      this.table.persistence.sort = true;
      this.table.persistence.page = true;
    }
    this.table = Object.assign({}, this.table);
    this.timeout.add(() => {
      this.show = true;
    }, 300);
  }
  //eslint-disable-next-line
  removeCart(data: any): void {
    this.table.data.find(item => data.id === item.id).removed = data.removed;
    this.cartItems = this.table.data;
    this.updateCartItems.emit(this.cartItems);
    // this.notRemovedCartItems = this.cartItems.filter(item => !item['removed']);
    this.table = Object.assign({}, this.table);
  }
  removeAllRows(value: boolean): void {
    this.table.data.forEach(item => (item.removed = value));
    this.cartItems = this.table.data;
    this.updateCartItems.emit(this.cartItems);
    // this.notRemovedCartItems = this.cartItems.filter(item => !item['removed']);
    this.table = Object.assign({}, this.table);
  }
}
